/* src/app/location-users/location-search/location-search.component.scss */
.search.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e668" !important;
  color: #FFF;
}
.clear.icon:before {
  font-family: upsicons, fantasy !important;
  content: "\e67b" !important;
  color: #FFF;
}
/*# sourceMappingURL=location-search.component.css.map */
